import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { MenuPage } from './pages/MenuPage';
import { ReservationsPage } from './pages/ReservationsPage';
import { CareersPage } from './pages/CareersPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/menu" element={<MenuPage data-id="element-5" />} data-id="element-4" />
        <Route path="/reservations" element={<ReservationsPage data-id="element-7" />} data-id="element-6" />
        <Route path="/careers" element={<CareersPage data-id="element-9" />} data-id="element-8" />
        <Route path="/contact" element={<ContactPage data-id="element-11" />} data-id="element-10" />
      </Routes>
    </Router>;
}